import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PlannedTransactionListDto } from '@/features/dashboard/plannedTransactions/types/PlannedTransactionListDto.ts';
import { PlannedTransactionDetailDto } from '@/features/dashboard/plannedTransactions/types/PlannedTransactionDetailDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';

const plannedTransactionsApi = {
  getTableDefinition: (): Promise<TableDefinitionDto> =>
    fetchPrivateApi<TableDefinitionDto>(
      'GET',
      'planned-transactions/table-definition',
    ),
  getAll: (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<PlannedTransactionListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return fetchPrivateApi<PagedDto<PlannedTransactionListDto>>(
      'POST',
      `planned-transactions/all?${params.toString()}`,
      filterCriteria,
    );
  },
  // Raty są harmonogramem wyliczanym z rachunku rezerwacji — ręczny CRUD
  // (POST/PUT/DELETE planned-transactions) został usunięty z API.
  getById: (id: string): Promise<PlannedTransactionDetailDto> =>
    fetchPrivateApi<PlannedTransactionDetailDto>(
      'GET',
      `planned-transactions/${id}`,
    ),
};

export default plannedTransactionsApi;
